import { setupAutoAnimate } from './auto-animate.js';

(function() {
  'use strict';

  /**
   * Initialize the filter functionality
   */
  function initFilters() {
    const gridParent = document.querySelector('.roster-grid');
    const tableBody = document.querySelector('.roster-table tbody');
    const filterButtons = Array.from(document.querySelectorAll('.roster-filter-btn[data-filter-position]'));
    const resetButton = document.querySelector('.roster-filter-reset');

    if (!gridParent || !tableBody || filterButtons.length === 0) {
      return;
    }

    setupAutoAnimate({
      elParents: [gridParent, tableBody],
      elReset: resetButton,
      elFilterButtons: filterButtons,
      dataAttributeOnItems: 'athletePosition',
      dataAttributeOnFilterButtons: 'filterPosition'
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilters);
  } else {
    initFilters();
  }
})();
